<template>
  <el-tooltip
    disabled
    :class="['item', {'no-drag': !isDraggable}]"
    effect="light"
    :content="tooltipText"
    placement="bottom"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <el-upload
      :drag="isDraggable"
      action="#"
      :auto-upload="false"
      :show-file-list="false"
      :on-change="UploadFile"
    >
      <div class="el-upload-wrapper">
        <img
          v-if="base64"
          :src="base64"
          class="image"
        >
        <el-button
          type="upload"
          :on-click="UploadFile"
          v-if="!base64"
        >
          {{ $t('form.preUploader.upload') }}
        </el-button>
        <el-row
          class="frame-overlay"
        >
          <div class="corners">
            <div class="corner top-left" />
            <div class="corner top-right" />
            <div class="corner bottom-right" />
            <div class="corner bottom-left" />
          </div>
        </el-row>
        <el-row
          class="instruction"
          onclick="event.stopPropagation()"
        >
          <span> {{ $t('form.preUploader.photoPlaceholder') }} </span>
        </el-row>
        <el-button
          type="upload"
          :on-click="UploadFile"
          class="new-img"
          v-if="base64"
        >
          {{ $t('form.preUploader.newUpload') }}
        </el-button>
      </div>
    </el-upload>
  </el-tooltip>
</template>

<script>
export default {
  name: 'PreUploader',
  props: {
    base64: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isDraggable: {
      type: Boolean,
      default: true
    },
    tooltipText: {
      type: String,
      default: ''
    },
    side: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      isLoaded: false,
      photo: '',
      convertFormat: ['heif', 'heifs', 'heic', 'heics'],
      allowedImageExtension: ['jpeg', 'jpg', 'png', 'jfif'],
      fullscreenLoading: false
    };
  },
  computed: {
    fileUrl: {
      get: function () {
        return this.base64;
      },
      set: function (value) {
        this.$emit('update:base64', value);
      }
    }
  },
  methods: {
    UploadFile (file) {
      this.fullscreenLoading = true;
      var re = /(?:\.([^.]+))?$/,
          ext = re.exec(file.raw.name)[1];

      if (this.side == 'front') {
        this.$emit('update:photo', file.raw);
      }

      if (this.convertFormat.includes(ext.toLowerCase())) {
        const data = new FormData();
        data.append('file', file.raw);

        this.$axios('/ImageConverter/ConvertToJpeg', {
          method: 'POST',
          headers: {'content-type': 'multipart/form-data'},
          data: data,
          responseType: 'arraybuffer'
        }).then((response) => {
          if (response.data){
            const imgStr = new Buffer.from(response.data, 'binary').toString('base64'),
                  prefix = "data:" + response.headers["content-type"] + ";base64,";
            this.fileUrl = prefix + imgStr;
            this.$emit('imageUploaded');
            this.isLoaded = true;
            this.fullscreenLoading = false;
          }
        }).catch(() => {
          this.setMessage(this.$t('form.preUploader.error'));
          this.fullscreenLoading = false;
        });
      } else {
        if (!this.allowedImageExtension.includes(ext.toLowerCase())) {
          this.$message.error('Photo cannot be uploaded! Incorrect format!');
          this.fullscreenLoading = false;
          return false;
        }
        var self = this,
            reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onloadend = function () {
          self.fileUrl = reader.result;
          self.$emit('imageUploaded');
        };
        this.isLoaded = true;
        this.fullscreenLoading = false;
      }
    }
  }
};
</script>
